export default {
      id: "duplicate-usage",
      viewBox: "0 0 14 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#duplicate",
      toString: function () {
        return this.url;
      }
    }